import request from '@/utils/request'

/**
 * @description 获取商品分类标签
 * @returns {*}
 */
export function getTagList() {
  return request.post('/phalapi/public/?service=App.Integral.GetTagList')
}

/**
 * @description 获取商品列表
 * @param data
 * @returns {*}
 */
export function getGoodList(data) {
  return request.post('/phalapi/public/?service=App.Integral.GoodList', data)
}

/**
 * @description 设置商品排序
 * @param data
 * @returns {*}
 */
export function setGoodSort(data) {
  return request.post('/phalapi/public/?service=App.Integral.SetGoodsSort', data)
}

/**
 * @description 设置商品上下架状态或删除
 * @param data
 * @returns {*}
 */
export function setGoodState(data) {
  return request.post('/phalapi/public/?service=App.Integral.SetGoodState', data)
}

/**
 * @description 设置子商品上下架状态
 * @param data
 * @returns {*}
 */
export function setSubGoodState(data) {
  return request.post('/phalapi/public/?service=App.Integral.SetSubGoodState', data)
}

/**
 * @description 获取商品详情
 * @param data
 * @returns {*}
 */
export function getGoodDetail(data) {
  return request.post('/phalapi/public/?service=App.Integral.GoodInfo', data)
}

/**
 * @description 获取停运模板列表
 * @param data
 * @returns {*}
 */
export function GetStopExpressList(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.GetStopExpressList', data)
}

/**
 * @description 保存商品分类标签
 * @param data
 * @returns {*}
 */
export function saveTag(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveTag', data)
}

/**
 * @description 删除商品分类标签
 * @param data
 * @returns {*}
 */
export function deleteTag(data) {
  return request.post('/phalapi/public/?service=App.Integral.DelTag', data)
}

/**
 * @description 保存商品
 * @param data
 * @returns {*}
 */
export function saveGood(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveGood', data)
}

/**
 * @description 请求推送消息
 * @param data
 * @returns {*}
 */
export function pushMsg(data) {
  return request.post('/phalapi/public/?service=App.Integral.CreateGoodsInformation', data)
}

/**
 * @description 预览推送消息
 * @param data
 * @returns {*}
 */
export function previewPushMsg(data) {
  return request.post('/phalapi/public/?service=App.Integral.MsgPreView', data)
}

/**
 * @description 获取推送信息
 * @param data
 * @returns {*}
 */
export function getPushInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetGoodsInformation', data)
}

/**
 * @description 更新商品库存
 * @param data
 * @returns {*}
 */
export function updateStock(data) {
  return request.post('/phalapi/public/?service=App.Integral.updateAndRecordStocks', data)
}

/**
 * @description 批量更新库存
 * @param {*} data
 * @returns
 */
export function updateStockByBatch(data) {
  return request.post('/phalapi/public/?service=App.Integral.doMultOperateStock', data)
}

/**
 * @description 获取库存记录列表
 * @param data
 * @returns {*}
 */
export function getStockList(data) {
  return request.post('/phalapi/public/?service=App.Integral.getStockStatisticsList', data)
}

/**
 * @description 获取库存日志
 * @param data
 * @returns {*}
 */
export function getStockLogList(data) {
  return request.post('/phalapi/public/?service=App.Integral.getStockLogsDetail', data)
}

//积分商品保存
export function saveIntegralGoods(data) {
  return request.post('/phalapi/public/?service=App.Integral.saveIntegralGoods', data)
}

//秒杀商品保存
export function saveSeckillGoods(data) {
  return request.post('/phalapi/public/?service=App.Integral.saveSeckillGoods', data)
}

//删除子商品
export function delSubgoods(data) {
  return request.post('/phalapi/public/?service=App.Integral.delSubgoods', data)
}

/**
 * @description 获取商品排序列表
 * @param {*} data
 * @returns
 */
export function getSortGoodList(data) {
  return request.post('/phalapi/public/?service=App.Integral.getGoodsOrderList', data)
}

/**
 * @description 保存商品排序
 * @param {*} data
 * @returns
 */
export function saveGoodSort(data) {
  return request.post('/phalapi/public/?service=App.Integral.setGoodsOrderBatch', data)
}

/**
 * @description 获取群发需要的商品信息
 * @param data
 * @returns {*}
 */
export function getGoodsInfoForMass(data) {
  return request.post('/phalapi/public/?service=App.Integral.getGoodsInfoForMass', data)
}

/**
 * @description 设置积分商城地区运费
 * @param data
 * @returns {*}
 */
export function setIntegralAreaExpressPrice(data) {
  return request.post('/phalapi/public/?service=App.Integral.setIntegralAreaExpressPrice', data)
}

/**
 * @description 获取积分商城地区运费
 * @param data
 * @returns {*}
 */
export function getIntegralAreaExpressPrice() {
  return request.post('/phalapi/public/?service=App.Setting.GetInfoByName', { varname: 'integral_area_express_fee', no_redis_cache: 1 })
}

/**
 * 供应商管理 start
 */

/**
 * @description 获取供应商列表
 * @param {*} data
 * @returns
 */
export function getSupplierList(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetSupplierList', data)
}

/**
 * @description 保存供应商信息
 * @param {*} data
 * @returns
 */
export function saveSupplierInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveSupplierInfo', data)
}

/**
 * @description 删除供应商
 * @param {*} data
 * @returns
 */
export function deleteSupplier(data) {
  return request.post('/phalapi/public/?service=App.Integral.DelSupplier', data)
}

/**
 * @description 切换供应商状态
 * @param {*} data
 * @returns
 */
export function switchSupplierState(data) {
  return request.post('/phalapi/public/?service=App.Integral.SwitchSupplierState', data)
}

/**
 * @description 获取订单模板内容标志列表
 * @returns
 */
export function getTradeTmplCharList() {
  return request.post('/phalapi/public/?service=App.Integral.getTradeCharList')
}

/**
 * 供应商管理 end
 */

/**
 * 单位管理 start
 */

/**
 * @description 获取单位列表
 * @returns {*}
 */
export function getUnitList() {
  return request.post('/phalapi/public/?service=App.Integral.getSubgoodsUnitList')
}

/**
 * @description 保存单位
 * @param {*} data
 * @returns
 */
export function saveUnitInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveSubgoodsUnit', data)
}

/**
 * @description 删除单位
 * @param {*} data
 * @returns
 */
export function deleteUnit(data) {
  return request.post('/phalapi/public/?service=App.Integral.DelSubgoodsUnit', data)
}

/**
 * 单位管理 end
 */

/**
 * 子商品管理 start
 */

/**
 * @description 获取子商品列表
 * @param {*} data
 * @returns
 */
export function getSubgoodList(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetSubgoodsList', data)
}

/**
 * @description 保存子商品信息
 * @param {*} data
 * @returns
 */
export function saveSubgoodInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.EditSubgoodsInfo', data)
}

/**
 * 子商品管理 end
 */

/**
 * 进销存记录 start
 */

/**
 * @description 获取供应商及对应子商品
 * @returns
 */
export function getSupplierAndSubgoods() {
  return request.post('/phalapi/public/?service=App.Integral.GetAllSupplierAndSubgoods')
}

/**
 * @description 保存采购订单
 * @param {*} data
 * @returns
 */
export function savePurchaseOrder(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveBuyOrderInfo', data)
}

/**
 * @description 删除采购订单
 * @param {*} data
 * @returns
 */
export function deletePurchaseOrder(data) {
  return request.post('/phalapi/public/?service=App.Integral.DelBuyOrder', data)
}

/**
 * @description 获取采购订单列表
 * @param {*} data
 * @returns
 */
export function getPurchaseList(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetBuyOrderList', data)
}

/**
 * @description 修改采购订单备注
 * @param {*} data
 * @returns
 */
export function saveEntryRemark(data) {
  return request.post('/phalapi/public/?service=App.Integral.saveOrderRemark', data)
}

/**
 * @description 获取订单详情
 * @param {*} data type: buy-采购，entry-入库
 * @returns
 */
export function getOrderInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetOrderInfo', data)
}

/**
 * @description 增加快递信息
 * @param {*} data
 * @returns
 */
export function addEmsInfo(data) {
  return request.post('/phalapi/public/?service=App.Integral.AddDeliveryInfo', data)
}

/**
 * @description 改变订单状态
 * @param {*} data
 * @returns
 */
export function changeOrderState(data) {
  return request.post('/phalapi/public/?service=App.Integral.ChangeBuyOrderState', data)
}

/**
 * @description 改变发票状态
 * @param {*} data
 * @returns
 */
export function changeInvoiceState(data) {
  return request.post('/phalapi/public/?service=App.Integral.changeBuyOrderInvoiceState', data)
}

/**
 * @description 采购订单入库
 * @param {*} data
 * @returns
 */
export function orderEntry(data) {
  return request.post('/phalapi/public/?service=App.Integral.EntryBuyOrder', data)
}

/**
 * @description 保存采购单备注
 * @param {*} data
 * @returns
 */
export function saveOrderRemark(data) {
  return request.post('/phalapi/public/?service=App.Integral.saveDeliveryRemark', data)
}

/**
 * 进销存记录 end
 */

/**
 * @description 获得重量比较数据
 * @param {*} data
 * @returns
 */
export function getWeightContrastData(data) {
  return request.post('/phalapi/public/?service=App.Trade.getWeightContrastData', data)
}

/**
 * @description 导出账单核对
 * @param {*} data
 * @returns
 */
export function exportContrastExcel(data) {
  return request.post('/phalapi/public/?service=App.Trade.exportContrastExcel', data)
}

/**
 * @description 保存供应商停运模板
 * @param {*} data
 * @returns
 */
export function saveSupplierStopExpress(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.SaveSupplierStopExpress', data)
}

/**
 * @description 获取供应商停运模板
 * @param {*} data
 * @returns
 */
export function getStopExpressInfo(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.GetStopExpressInfo', data)
}

/**
 * @description 快递账单上传
 * @param {*} data
 * @returns
 */
export function importSupplierExpressData(data) {
  return request.post('/phalapi/public/?service=App.integral.importSupplierExpressData', data)
}

/**
 * @description 获得供应商在指定周期的对账单详情
 * @param {*} data
 * @returns
 */
export function getSupplierBill(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetSupplierBill', data)
}

/**
 * @description 保存供应商异常订单操作
 * @param {*} data
 * @returns
 */
export function saveSupplierExceptionOrder(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveSupplierExceptionOrder', data)
}

/**
 * @description 导出供应商账单数据
 * @param {*} data
 * @returns
 */
export function exportSupplierBillExcel(data) {
  return request.post('/phalapi/public/?service=App.Integral.ExportSupplierBillExcel', data)
}

/**
 * @description 查看历史对账单页
 * @param {*} data
 * @returns
 */
export function getHistoricalBills(data) {
  return request.post('/phalapi/public/?service=App.Integral.GetHistoricalBills', data)
}

/**
 * @description 结算账单
 * @param {*} data
 * @returns
 */
export function settleBill(data) {
  return request.post('/phalapi/public/?service=App.Integral.SettleBill', data)
}

/**
 * @description 导出历史对账单数据
 * @param {*} data
 * @returns
 */
export function exportHistoricalBillsExcel(data) {
  return request.post('/phalapi/public/?service=App.integral.exportHistoricalBillsExcel', data)
}

/**
 * @description 获得有账单的供应商列表
 * @param {*} data
 * @returns
 */
export function getSuppliersHasBill() {
  return request.post('/phalapi/public/?service=App.Integral.GetSuppliersHasBill')
}
/**
 * @description 保存商品推送消息内容
 * @param {*} data
 * @returns
 */
export function saveGoodsMsgApi(data) {
  return request.post('/phalapi/public/?service=App.Integral.SaveGoodsMsg', data)
}
